import { useSelect } from '../hooks/useCoreContext';

const TriggerInput = (props: React.InputHTMLAttributes<HTMLInputElement>) => {
	const {
		inputValue,
		onInputChange,
		setOpen,
		ids,
		open,
		getReferenceProps,
		onEnter,
		dontOpenDropdownIfNoOptions,
		visibleOptions,
	} = useSelect();

	const handleFocus = () => {
		const canOpen = !dontOpenDropdownIfNoOptions || (visibleOptions?.length ?? 0) > 0;
		if (canOpen) setOpen(true);
	};

	return (
		<input
			autoComplete='off'
			type='search'
			{...getReferenceProps({
				value: inputValue,
				onChange: (e: React.ChangeEvent<HTMLInputElement>) => onInputChange(e.target.value),
				onFocus: () => handleFocus(),

				placeholder: props.placeholder,
				'aria-autocomplete': 'list',
				onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
					if (e.key.length === 1) {
						if (!open) setOpen(true);
					}
					if (e.key === 'Enter' && open) {
						e.preventDefault();
						if (props.disabled) return;
						e.stopPropagation();
						onEnter(e);
					}
				},
			})}
			id={ids.input}
			className={`border-none outline-none bg-transparent w-full text-secondary placeholder-text-tertiary`}
			placeholder={props.placeholder}
			{...props}
		/>
	);
};

export default TriggerInput;
